import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';
export { DesktopHeader, MobileHeader, DesktopFooter, MobileFooter };